<template>
  <v-row
    :class=" className || ' mt-5'"
    no-gutters>
    <v-col class="flex flex-wrap align-center">
      <StepNumber
        :disabled="disabled"/>
    </v-col>
    <v-col class="d-flex align-center justify-end">
      <NextStep @next="changeStep(true)"/>
    </v-col>
  </v-row>
</template>
<script>
import NextStep from 'components/tenders/NextStep.vue'
import StepNumber from 'components/common/elements/StepNumber.vue'

import { modalMixin, tenderMixin } from 'mixins'

export default {
  name: 'stepsInfo',
  mixins: [ tenderMixin, modalMixin ],
  props: {
    className: String,
    disabled: {
      type: Boolean
    },
  },
  components: {
    NextStep,
    StepNumber,
  }
}
</script>
